const state = {
    imgs: [],
    allImg: []
}
const mutations = {
    set_imgs(state, img) {
        state.imgs = img
    },
    set_allImg(state, imgs) {
        state.allImg = imgs
    }
}

export default {
    namespaced: true,
    state,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/module/ourServices.js